/**
 * Molecule Weight Loss Assessment — step config (Figma 813:9340)
 * One phase ≈ one Figma frame. Branching via showIf / skipIf / nextPhaseId.
 */
window.wmAssessmentConfig = {
  successRedirectUrl: '/pages/select-product',
  /* TEMP: set true to skip PLP redirect and show thank-you only */
  disableSuccessRedirect: false,
  successRedirectDelayMs: 4000,
  homeUrl: '/',
  clinicianBookingUrl: '/pages/book-a-consultation',
  logoAlt: 'Molecule',
  storageKey: 'webmed_wl_assessment',
  storageTtlMs: 20 * 60 * 1000,
  api: {
    url: 'https://demo-app-config.looprx.io/api/create-assessment',
    imagesUrl: 'https://demo-app-config.looprx.io/api/upload-assessment-images-v3',
    categoryId: 1,
    tenant: 'webmed',
    formType: 'webmed',
    authCookie: 'access_token',
    uploadcarePubkey: 'c73768e131ec40847fe1'
  },
  /* Height cm / weight kg clinical bounds shown in Figma limit screens */
  limits: {
    heightMinCm: 120,
    heightMaxCm: 220,
    weightMinKg: 45,
    weightMaxKg: 150,
    ageMin: 18,
    ageMax: 75
  },
  phases: [
    {
      id: 'q1-details',
      type: 'details',
      progress: 0,
      showBack: false,
      heading: 'Please enter your details',
      nextLabel: 'Continue'
    },
    {
      id: 'q1a-reason',
      type: 'multiselect',
      progress: 8,
      showBack: true,
      field: 'weight_loss_reasons',
      heading: "What's your main reason (or reasons) for wanting to lose weight?",
      hint: 'Select all that apply',
      exclusiveValue: 'other',
      otherValue: 'other',
      otherPlaceholder: 'Please tell us more',
      options: [
        { label: 'Improve my long-term health', value: 'long-term-health' },
        { label: 'Feel more confident in my body', value: 'confidence' },
        { label: 'Feel stronger, more energised, and rested', value: 'energised' },
        { label: 'Improve my mobility and reduce pain', value: 'mobility' },
        { label: 'Make it easier to move around and exercise', value: 'exercise' },
        { label: 'Address specific health issues', value: 'health-issues' },
        { label: 'Improve my mental wellbeing', value: 'mental' },
        { label: 'Other', value: 'other' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q1b-previous-methods',
      type: 'multiselect',
      progress: 12,
      showBack: true,
      field: 'previous_weight_loss_methods',
      heading: 'What have you previously tried to lose weight?',
      hint: 'Select all that apply',
      exclusiveValues: ['none', 'other'],
      options: [
        { label: 'Changes to my diet', value: 'diet' },
        { label: 'Increased exercise', value: 'exercise' },
        {
          label: 'A structured weight-loss programme',
          value: 'structured-programme'
        },
        { label: 'Weight-loss medication', value: 'medication' },
        {
          label: 'Support from a healthcare professional',
          value: 'healthcare-support'
        },
        { label: 'Other', value: 'other' },
        {
          label: 'I have not previously tried to lose weight',
          value: 'none'
        }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q2-dob',
      type: 'dob',
      progress: 15,
      showBack: true,
      heading: 'What is your date of birth?',
      rejectUnder18PhaseId: 'reject-under-18',
      rejectOver75PhaseId: 'cl-booking-over-75',
      nextLabel: 'Continue'
    },
    {
      id: 'reject-under-18',
      type: 'reject',
      routeOnly: true,
      progress: 15,
      showBack: false,
      heading: 'Your safety is our top priority',
      body:
        "Based on your answers, we're not able to prescribe this medication at this time. Weight loss treatments are only suitable for adults 18 and over.\nYour health matters please speak with your doctor about the support available to you.",
      nextLabel: 'Go back to Home'
    },
    {
      id: 'cl-booking-over-75',
      type: 'notice',
      routeOnly: true,
      hideChrome: true,
      showBack: false,
      heading: "We'd like to learn more about you",
      body:
        'Based on your answers, one of our clinicians would like to review your case before we proceed. This helps us make sure we recommend the safest and most effective treatment for you.',
      nextLabel: 'Book a Clinician Review',
      nextAction: 'book-clinician',
      showArrow: true
    },
    {
      id: 'q2-height',
      type: 'height',
      progress: 22,
      showBack: true,
      heading: 'What is your current height?',
      hint: "This helps us calculate your BMI and check if you're eligible for treatment safely and accurately",
      nextLabel: 'Continue'
    },
    {
      id: 'q2-weight',
      type: 'weight',
      progress: 28,
      showBack: true,
      heading: 'What is your current weight?',
      hint: "This helps us calculate your BMI and check if you're eligible for treatment safely and accurately",
      rejectBmiPhaseId: 'reject-bmi',
      nextLabel: 'Continue'
    },
    {
      id: 'reject-bmi',
      type: 'reject',
      routeOnly: true,
      progress: 28,
      showBack: false,
      heading: "Based on your BMI, we can't continue online",
      body:
        'Based on your height and weight, your BMI is below 23 and you may not be eligible for online treatment.\nPlease speak with your GP for further support.',
      nextLabel: 'Go back to Home'
    },
    {
      id: 'q3a-weight-checked',
      type: 'single',
      progress: 32,
      showBack: true,
      field: 'weight_last_checked',
      heading: 'When did you last check the weight you entered?',
      options: [
        { label: 'Today', value: 'today' },
        { label: 'Within the last 7 days', value: 'last-7-days' },
        { label: 'Within the last month', value: 'last-month' },
        { label: 'More than one month ago', value: 'over-one-month' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q4-ethnicity',
      type: 'single',
      progress: 35,
      showBack: true,
      field: 'Ethnicity',
      heading: 'What ethnicity are you?',
      otherValue: 'other',
      otherPlaceholder: 'Please mention your ethnicity',
      options: [
        { label: 'Asian or Asian British', value: 'asian' },
        {
          label: 'Black, Black British, Caribbean, or African',
          value: 'black'
        },
        {
          label: 'Latino/Hispanic or Latino or Hispanic British',
          value: 'latino'
        },
        {
          label: 'Middle Eastern or Middle Eastern British',
          value: 'middle-eastern'
        },
        { label: 'Mixed or multiple ethnic groups', value: 'mixed' },
        {
          label: 'White (British/Irish or other white backgrounds)',
          value: 'white'
        },
        { label: 'Other Ethnic Group', value: 'other' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q5-sex',
      type: 'single',
      progress: 42,
      showBack: true,
      field: 'sex',
      heading: 'What sex were you assigned at birth?',
      options: [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' },
        { label: 'Prefer not to say', value: 'prefer-not-to-say' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q5-pregnancy',
      type: 'single',
      progress: 44,
      showBack: true,
      field: 'currently_pregnant',
      showIf: { field: 'sex', equals: 'female' },
      heading: 'Are you currently pregnant, trying to get pregnant, or breastfeeding?',
      options: [
        {
          label: 'Pregnant',
          value: 'pregnant',
          nextPhaseId: 'reject-pregnancy'
        },
        {
          label: 'Actively trying to conceive',
          value: 'trying-to-conceive',
          nextPhaseId: 'reject-trying-to-conceive'
        },
        {
          label: 'Planning to conceive in the next 3 months',
          value: 'planning-to-conceive',
          nextPhaseId: 'reject-planning-to-conceive'
        },
        {
          label: 'Breast feeding',
          value: 'breastfeeding',
          nextPhaseId: 'reject-breastfeeding'
        },
        { label: 'None of the above', value: 'none' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'reject-pregnancy',
      type: 'reject',
      progress: 90,
      showBack: false,
      heading: "We're unable to prescribe this treatment during pregnancy",
      body:
        "There is currently limited safety data on weight loss medication during pregnancy, so we can't offer this service to you right now.\nPlease speak with your midwife or GP, they can support you with safe options throughout your pregnancy.",
      nextLabel: 'Go back to Home'
    },
    {
      id: 'reject-trying-to-conceive',
      type: 'reject',
      progress: 90,
      showBack: false,
      heading: "This treatment isn't recommended while trying to conceive",
      body:
        "Weight loss medication is not currently advised for those actively trying to get pregnant. Your safety and any future pregnancy come first.\nWe'd recommend having a conversation with your GP before starting any weight loss treatment.\nPlease speak with your midwife or GP, they can support you with safe options throughout your pregnancy.",
      nextLabel: 'Go back to Home'
    },
    {
      id: 'reject-planning-to-conceive',
      type: 'reject',
      progress: 90,
      showBack: false,
      heading: "This treatment isn't recommended if you're planning to conceive in next 3 months",
      body:
        "Weight loss medication is not currently advised for those planning to conceive in next 3 months. Your safety and any future pregnancy come first.\nWe'd recommend having a conversation with your GP before starting any weight loss treatment.\nPlease speak with your midwife or GP, they can support you with safe options throughout your pregnancy.",
      nextLabel: 'Go back to Home'
    },
    {
      id: 'reject-breastfeeding',
      type: 'reject',
      progress: 90,
      showBack: false,
      heading: "We can't prescribe this treatment while you're breastfeeding",
      body:
        "It's currently unknown whether GLP-1 medication passes into breast milk, and your baby's safety is our priority. Once you've finished breastfeeding, you're welcome to return and complete the assessment. In the meantime, your GP can advise on safe alternatives.",
      nextLabel: 'Go back to Home'
    },
    {
      id: 'q5-oral-contraceptive',
      type: 'single',
      progress: 46,
      showBack: true,
      field: 'currently_taking_contraceptive',
      showIf: { field: 'currently_pregnant', equals: 'none' },
      heading: 'Are you currently taking oral contraceptives (the pill)?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q5-able-pregnant',
      type: 'single',
      progress: 46,
      showBack: true,
      field: 'able_to_become_pregnant',
      showIf: { field: 'sex', equals: 'prefer-not-to-say' },
      heading: 'Are you able to become pregnant?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
        { label: 'Unsure', value: 'unsure' },
        { label: 'Prefer not to say', value: 'prefer-not-to-say' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q5-contraception-method',
      type: 'single',
      progress: 48,
      showBack: true,
      field: 'current_contraception',
      showIf: {
        field: 'able_to_become_pregnant',
        in: ['yes', 'unsure', 'prefer-not-to-say']
      },
      heading: 'What contraception are you currently using?',
      otherValue: 'other',
      otherPlaceholder: 'Please mention',
      /* All answers continue to weight-loss medication history (skip pill info / HRT) */
      nextPhaseId: 'q6-meds',
      options: [
        { label: 'Combined oral contraceptive pill', value: 'combined-pill' },
        { label: 'Progestogen-only pill', value: 'progestogen-only-pill' },
        { label: 'Implant', value: 'implant' },
        { label: 'Injection', value: 'injection' },
        { label: 'Hormonal coil', value: 'hormonal-coil' },
        { label: 'Copper coil', value: 'copper-coil' },
        { label: 'Patch', value: 'patch' },
        { label: 'Vaginal ring', value: 'vaginal-ring' },
        { label: 'Barrier contraception', value: 'barrier' },
        { label: 'Sterilisation', value: 'sterilisation' },
        { label: 'Other', value: 'other' },
        { label: 'I am not currently using contraception', value: 'none' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q5-contraception-info',
      type: 'infoAck',
      progress: 50,
      showBack: true,
      field: 'contraception_ack',
      showIf: {
        or: [
          { field: 'currently_taking_contraceptive', equals: 'yes' },
          {
            field: 'current_contraception',
            in: ['combined-pill', 'progestogen-only-pill']
          }
        ]
      },
      heading: 'Important information about your contraception',
      bodyParagraphs: [
        'Weight loss medication can reduce how effectively the contraceptive pill works.',
        'To avoid an unplanned pregnancy, it is recommended to switch to a non-oral method of contraception, such as a coil or implant. Or use a barrier method of contraception, such as condoms:'
      ],
      bodyList: [
        'for 4 weeks after starting weight loss medication',
        'and 4 weeks after every dose increase'
      ],
      confirmLabel:
        'I understand and will use an additional contraceptive method as advised',
      nextLabel: 'Continue'
    },
    {
      id: 'q5-hrt',
      type: 'single',
      progress: 54,
      showBack: true,
      field: 'currently_taking_oral_hrt',
      showIf: { field: 'sex', equals: 'female' },
      heading: 'Are you currently taking oral Hormone Replacement Therapy (HRT)?',
      hint: 'This includes oral oestrogen or progesterone tablets.',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q5-hrt-info',
      type: 'infoAck',
      progress: 56,
      showBack: true,
      field: 'hrt_ack',
      showIf: { field: 'currently_taking_oral_hrt', equals: 'yes' },
      heading: 'Important information about your HRT',
      bodyParagraphs: [
        'Weight loss medication is safe to use alongside HRT, but it may affect how your body absorbs oral hormones.',
        'If you take oral oestrogen or progesterone, we recommend speaking with your GP about:'
      ],
      bodyList: [
        'Switching to a non-oral HRT option, such as patches or gels',
        'Temporarily increasing your progesterone dose during your first four weeks of treatment'
      ],
      confirmLabel:
        'I understand and will speak to my GP about my HRT before starting treatment',
      nextLabel: 'Continue'
    },
    {
      id: 'q6-meds',
      type: 'single',
      progress: 58,
      showBack: true,
      field: 'medications_to_aid_in_weight_loss',
      heading: 'Have you ever taken or currently taking the following medication?',
      options: [
        { label: 'Foundayo', value: 'foundayo' },
        { label: 'Mounjaro (Tirzepatide)', value: 'mounjaro' },
        { label: 'Wegovy Injection', value: 'wegovy-injection' },
        { label: 'Wegovy Pill', value: 'wegovy-pill' },
        { label: 'Saxenda', value: 'saxenda' },
        { label: 'Victoza', value: 'victoza' },
        { label: 'Rybelsus', value: 'rybelsus' },
        { label: 'None of the above', value: 'none' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q6-strength',
      type: 'single',
      progress: 62,
      showBack: true,
      field: 'last_dose_strength',
      showIf: {
        field: 'medications_to_aid_in_weight_loss',
        in: [
          'foundayo',
          'mounjaro',
          'wegovy-injection',
          'wegovy-pill',
          'saxenda',
          'victoza',
          'rybelsus'
        ]
      },
      heading: 'Please tell us the strength you last administered',
      dosesByMed: {
        foundayo: ['0.8mg', '2.5mg', '5.5mg', '9mg', '14.5mg', '17.2mg'],
        mounjaro: ['2.5mg', '5mg', '7.5mg', '10mg', '12.5mg', '15mg'],
        'wegovy-injection': ['0.25mg', '0.5mg', '1mg', '1.7mg', '2.4mg'],
        'wegovy-pill': ['1.5mg', '4mg', '9mg', '25mg'],
        saxenda: ['0.6mg', '1.2mg', '1.8mg', '2.4mg', '3mg'],
        victoza: ['0.6mg', '1.2mg', '1.8mg'],
        rybelsus: ['3mg', '7mg', '14mg']
      },
      nextLabel: 'Continue'
    },
    {
      id: 'q6-weight-lost',
      type: 'weightLost',
      progress: 64,
      showBack: true,
      field: 'weight_lost_on_treatment',
      statusField: 'weight_lost_status',
      showIf: { field: 'medications_to_aid_in_weight_loss', equals: 'foundayo' },
      heading: 'How much weight did you lose using this treatment?',
      choiceOptions: [
        { label: 'I did not lose weight', value: 'none' },
        { label: 'I am unsure', value: 'unsure' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q6-stop-reason',
      type: 'single',
      progress: 65,
      showBack: true,
      field: 'why_stopped_treatment',
      showIf: { field: 'medications_to_aid_in_weight_loss', equals: 'foundayo' },
      heading: 'Why did you stop this treatment?',
      options: [
        { label: 'I am still taking it', value: 'still-taking' },
        { label: 'Treatment completed', value: 'completed' },
        { label: 'Side effects', value: 'side-effects' },
        { label: 'It was not effective', value: 'not-effective' },
        { label: 'Cost or availability', value: 'cost-availability' },
        {
          label: 'Advised to stop by a healthcare professional',
          value: 'advised-to-stop'
        },
        { label: 'Other', value: 'other' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q6-side-effects',
      type: 'single',
      progress: 66,
      showBack: true,
      field: 'experienced_side_effects',
      showIf: { field: 'medications_to_aid_in_weight_loss', equals: 'foundayo' },
      heading: 'Did you experience any side effects?',
      otherValue: 'yes',
      otherPlaceholder: 'Please describe the side effects you experienced',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q6-prescription-date',
      type: 'calendar',
      progress: 68,
      showBack: true,
      showIf: {
        field: 'medications_to_aid_in_weight_loss',
        in: [
          'mounjaro',
          'wegovy-injection',
          'wegovy-pill',
          'saxenda',
          'victoza',
          'rybelsus'
        ]
      },
      field: 'last_dose_date',
      heading:
        'On what date did you administer, or will you administer, your final dose?',
      nextLabel: 'Continue',
      /* Figma annotations on calendar:
       * - If date > 3 months ago → skip previous-supply photo upload
       * - Mounjaro: if date > 6 weeks ago → restart from lowest dose (2.5mg)
       * - Wegovy: if date > 5 weeks ago → restart from lowest dose
       */
      skipUploadIfOlderThanMonths: 3,
      restartLowestDose: {
        mounjaro: { weeks: 6, dose: '2.5mg' },
        'wegovy-injection': { weeks: 5, dose: '0.25mg' },
        'wegovy-pill': { weeks: 5, dose: '1.5mg' }
      }
    },
    {
      id: 'q6-upload-rx',
      type: 'upload',
      progress: 70,
      showBack: true,
      showIf: [
        {
          field: 'medications_to_aid_in_weight_loss',
          in: [
            'mounjaro',
            'wegovy-injection',
            'wegovy-pill',
            'saxenda',
            'victoza',
            'rybelsus'
          ]
        },
        { field: '_skip_rx_upload', notEquals: true }
      ],
      uploadKey: 'prescription',
      uploadVariant: 'proof',
      heading: 'Proof of previous supply',
      bodyParagraphs: [
        'Please upload a photo of the dispensing label or an order confirmation email from your previous supplier that clearly shows:'
      ],
      bodyList: ['The medication', 'The date it was dispensed', 'Your name'],
      uploadLabel: 'Click to upload Image',
      uploadHint: 'PNG,JPG, PDF or GIF (max, 3MB)',
      nextLabel: 'Continue',
      allowSkip: false
    },
    {
      id: 'q7-conditions',
      type: 'multiselect',
      progress: 75,
      showBack: true,
      field: 'medical_conditions',
      heading: 'Please select any of the following medical conditions if they apply to you',
      exclusiveValue: 'none',
      exclusiveValues: ['none', 'other'],
      otherValue: 'other',
      otherPlaceholder: 'Please mention your condition',
      clinicianReviewValues: true,
      options: [
        { label: 'I do not have any medical condition', value: 'none' },
        {
          label: 'Acid reflux/Gastro-Oesophageal Reflux Disease (GORD)',
          value: 'gord',
          clinicianReview: true
        },
        { label: 'Active cancer or a history of cancer', value: 'cancer', clinicianReview: true },
        { label: 'Atrial Fibrillation (AF)', value: 'af', clinicianReview: true },
        { label: 'Asthma', value: 'asthma', clinicianReview: true },
        { label: 'Chronic back pain', value: 'back-pain', clinicianReview: true },
        {
          label: 'Chronic kidney disease with reduced function',
          value: 'ckd',
          clinicianReview: true
        },
        { label: 'COPD', value: 'copd', clinicianReview: true },
        { label: 'Diabetic retinopathy', value: 'retinopathy', clinicianReview: true },
        { label: 'Diagnosed Depression', value: 'depression', clinicianReview: true },
        { label: 'Endometriosis', value: 'endometriosis', clinicianReview: true },
        { label: 'Fatty Liver', value: 'fatty-liver', clinicianReview: true },
        {
          label: 'Gallstones or Gallbladder disease',
          value: 'gallbladder',
          clinicianReview: true
        },
        {
          label:
            'Gastrointestinal surgery in the last 3 months (e.g. stomach, bowel or gallbladder)',
          value: 'gi-surgery',
          clinicianReview: true
        },
        { label: 'Gastroparesis', value: 'gastroparesis', clinicianReview: true },
        {
          label: 'Heart failure with shortness of breath at rest',
          value: 'heart-failure',
          clinicianReview: true
        },
        { label: 'High Blood Pressure', value: 'hypertension', clinicianReview: true },
        {
          label: 'High Cholesterol or High Triglycerides',
          value: 'cholesterol',
          clinicianReview: true
        },
        {
          label: 'Heart disease including angina or heart attack',
          value: 'heart-disease',
          clinicianReview: true
        },
        {
          label: "Inflammatory bowel disease (including Crohn's or ulcerative colitis)",
          value: 'ibd',
          clinicianReview: true
        },
        { label: 'Liver disease (cirrhosis)', value: 'cirrhosis', clinicianReview: true },
        {
          label: 'Multiple Endocrine Neoplasia type 2 (MEN2)',
          value: 'men2',
          clinicianReview: true
        },
        { label: 'Osteoarthritis', value: 'osteoarthritis', clinicianReview: true },
        { label: 'Pancreatitis', value: 'pancreatitis', clinicianReview: true },
        { label: 'Pre-diabetes', value: 'prediabetes', clinicianReview: true },
        { label: 'PCOS', value: 'pcos', clinicianReview: true },
        { label: 'Sleep Apnoea', value: 'osa', clinicianReview: true },
        { label: 'Stroke/TIA', value: 'stroke', clinicianReview: true },
        {
          label: 'T-Cell Medullary Thyroid cancer',
          value: 'mtc',
          clinicianReview: true
        },
        { label: 'Type 1 diabetes', value: 't1d', clinicianReview: true },
        { label: 'Type 2 diabetes', value: 't2d', clinicianReview: true },
        {
          label: 'Weight-loss related surgery in the last 12 months',
          value: 'bariatric',
          clinicianReview: true
        },
        { label: 'Other - please mention', value: 'other' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q7a-meds',
      type: 'multiselect',
      progress: 80,
      showBack: true,
      field: 'other_medical_conditions',
      heading: 'Do you take any of the following medications?',
      exclusiveValues: ['none', 'other'],
      otherValue: 'other',
      otherPlaceholder: 'Please mention the medication',
      allowEmpty: true,
      /* Figma 1596:1904 — Clinician review on annotated options; info screens keep triggerInfo */
      options: [
        {
          label: 'Clarithromycin or erythromycin',
          value: 'clarithromycin-erythromycin',
          clinicianReview: true
        },
        {
          label: 'Ketoconazole or itraconazole',
          value: 'ketoconazole-itraconazole',
          clinicianReview: true
        },
        {
          label: 'Ritonavir or telaprevir',
          value: 'ritonavir-telaprevir',
          clinicianReview: true
        },
        {
          label: 'Carbamazepine or phenytoin',
          value: 'carbamazepine-phenytoin',
          clinicianReview: true
        },
        { label: 'Bosentan', value: 'bosentan', clinicianReview: true },
        { label: 'Efavirenz', value: 'efavirenz', clinicianReview: true },
        { label: 'Rifampicin', value: 'rifampicin', clinicianReview: true },
        { label: "St John's Wort", value: 'st-johns-wort', clinicianReview: true },
        { label: 'Topotecan', value: 'topotecan', clinicianReview: true },
        {
          label: 'Ciclosporin or another immunosuppressant',
          value: 'ciclosporin-immunosuppressant',
          clinicianReview: true
        },
        { label: 'Rosuvastatin', value: 'rosuvastatin', clinicianReview: true },
        { label: 'Simvastatin', value: 'simvastatin', clinicianReview: true },
        { label: 'Amiodarone', value: 'amiodarone', clinicianReview: true },
        { label: 'Azelastine', value: 'azelastine', clinicianReview: true },
        {
          label: 'Anti-hypertensive drugs',
          value: 'antihypertensive',
          triggerInfo: 'info-antihypertensive'
        },
        { label: 'Carbamazepine', value: 'carbamazepine', clinicianReview: true },
        {
          label: 'Cyclosporin, Methotrexate (Oral Tablets)',
          value: 'cyclosporin-methotrexate',
          clinicianReview: true
        },
        { label: 'Clozapine', value: 'clozapine', clinicianReview: true },
        { label: 'Digoxin', value: 'digoxin', clinicianReview: true },
        { label: 'Fenfluramine', value: 'fenfluramine', clinicianReview: true },
        { label: 'HIV medications', value: 'hiv', clinicianReview: true },
        { label: 'Insulin', value: 'insulin', clinicianReview: true },
        {
          label: 'Levothyroxine',
          value: 'levothyroxine',
          clinicianReview: true,
          triggerInfo: 'info-levothyroxine'
        },
        { label: 'Lithium', value: 'lithium', clinicianReview: true },
        { label: 'Metformin', value: 'metformin', triggerInfo: 'info-metformin' },
        { label: 'Mycophenolate', value: 'mycophenolate', clinicianReview: true },
        {
          label: 'Phenobarbital, Phenytoin',
          value: 'phenobarbital-phenytoin',
          clinicianReview: true
        },
        {
          label: 'SGLT-2i (Dapaglifozin, Canaglifozin & Empaglifozin)',
          value: 'sglt2i',
          triggerInfo: 'info-metformin'
        },
        { label: 'Somatrogon', value: 'somatrogon', clinicianReview: true },
        { label: 'Sulfonylurea', value: 'sulfonylurea', clinicianReview: true },
        { label: 'Tacrolimus/Pimecrolimus', value: 'tacrolimus', clinicianReview: true },
        {
          label: 'Warfarin',
          value: 'warfarin',
          triggerInfo: 'info-warfarin'
        },
        { label: 'None of the above', value: 'none' },
        { label: 'Other', value: 'other', clinicianReview: false }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'info-metformin',
      type: 'infoAck',
      routeOnly: true,
      progress: 80,
      showBack: true,
      field: 'metformin_ack',
      heading: 'Important information about your medication',
      bodyParagraphs: [
        "Hypoglycaemia is a blood sugar level lower than the normal range. For most people without diabetes, not eating food for a long time (fasting) doesn't lead to hypoglycaemia. This is because your body uses hormones and stored glucose to manage your blood sugar. Hypoglycaemia can occur with significant dieting and exercise when you have used up the glucose in your blood as well as the glucose stored up in your liver called glycogen.",
        "There's a low risk of mild hypoglycaemia episodes if you take injectable medical weight loss treatments. This is very rare in patients with Type 2 diabetes who are on oral medications that are not meant to cause low blood sugars such as Metformin or one of the \"gliptins\" or one of the SGLT2 inhibitors or \"flozins\".",
        'This can occur if your appetite is so well controlled that you are skipping meals! To avoid hypoglycaemia in this scenario always ensure regular low calorie, low carb meals with a low glycaemic index, which means that your sugar levels are more sustained and you do not run the risk of hypoglycaemia.',
        'Hypoglycaemia can become a greater risk if you are on injectable weight loss medications alongside other medications that can lower blood sugar, like sulfonylureas (gliclazide or glimepiride) or insulin. The dose of these medications may need to be reduced when starting injections of Mounjaro or Wegovy or other weight loss medications.',
        'If you have type 2 diabetes and you are on treatment, your clinician will ensure that these checks are in place to make sure you avoid hypoglycaemia and have a safe and enjoyable weight loss journey.',
        'If you are on Metformin, abdominal bloating, cramp and diarrhoea are some of the side effects associated with Metformin. This usually only happens at higher doses. Some people who are already on Metformin can experience more nausea, bloating and diarrhoea on an ongoing basis during their treatment with Mounjaro or Wegovy. This can happen more as you approach a healthy target weight. If this does happen it may require a dose reduction in the Metformin.'
      ],
      confirmLabel: 'I understand and I will speak to my GP if required.',
      nextLabel: 'Continue'
    },
    {
      id: 'info-levothyroxine',
      type: 'infoAck',
      routeOnly: true,
      progress: 80,
      showBack: true,
      field: 'levothyroxine_ack',
      heading: 'Important information about your medication',
      bodyParagraphs: [
        'We note that you are on Levothyroxine. Being on Levothyroxine is not a contraindication to treatment with Mounjaro or Wegovy; however, these medications delay gastric emptying (i.e. they slow down emptying of the stomach) and can possibly impact the absorption of the levothyroxine in your stomach. We advise you to take your Levothyroxine at least 45 minutes to an hour before you have breakfast (compared to the usual 30 minutes that is recommended). Also, even if you are not scheduled for your regular thyroid blood test it is best to have your levels checked 3 months after you have started your weight loss medication as sometimes the dose of levothyroxine needs to be adjusted.'
      ],
      confirmLabel: 'I understand and I will speak to my GP if required.',
      nextLabel: 'Continue'
    },
    {
      id: 'info-antihypertensive',
      type: 'infoAck',
      routeOnly: true,
      progress: 80,
      showBack: true,
      field: 'antihypertensive_ack',
      heading: 'Important information about your medication',
      bodyParagraphs: [
        'We note that you are on blood pressure lowering medications. Losing even just 5 pounds (2.3 kilograms) can lower your blood pressure. The more weight you lose, the more blood pressure can drop. As you lose weight, it may be possible to reduce your dose of blood pressure medicine. Or you might be able to stop taking blood pressure medicine completely. Never make changes to your blood pressure medicine on your own. We would encourage obtaining a home BP machine and keeping a diary of BP readings to share with your GP. If your BP starts to become too low or you develop symptoms of low blood pressure such as light headedness or dizziness please make an appointment to see your GP or contact NHS 111.'
      ],
      confirmLabel: 'I understand and I will speak to my GP if required.',
      nextLabel: 'Continue'
    },
    {
      id: 'info-warfarin',
      type: 'infoAck',
      routeOnly: true,
      progress: 80,
      showBack: true,
      field: 'warfarin_ack',
      /* Figma 1596:2634 */
      heading: 'Important information about your medication',
      bodyParagraphs: [
        'We note that you are taking Warfarin. Taking warfarin is not a contraindication to treatment with weight loss treatments however, these medications delay gastric emptying (i.e. they slow down emptying of the stomach) and can possibly impact the absorption of the Warfarin in your stomach. As your INR will be monitored regularly please let the anticoagulant clinic or your GP know that you are starting treatment with a weight loss medication so that they can check and monitor your INR more closely.'
      ],
      confirmLabel: 'I understand and I will speak to my GP if required.',
      nextLabel: 'Continue'
    },
    {
      id: 'q7b-mental-health',
      type: 'single',
      progress: 81,
      showBack: true,
      field: 'mental_health_condition',
      heading:
        'Do you currently have, or have you previously experienced, a mental-health condition?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q7c-diabetes',
      type: 'multiselect',
      progress: 82,
      showBack: true,
      field: 'diabetes_medicines',
      heading: 'Which medicines do you take for diabetes?',
      exclusiveValue: 'none',
      otherValue: 'other',
      otherPlaceholder: 'Please mention the name and dose of the medicine',
      options: [
        { label: 'Insulin', value: 'insulin' },
        { label: 'A sulfonylurea', value: 'sulfonylurea' },
        { label: 'Metformin', value: 'metformin' },
        { label: 'An SGLT2 inhibitor', value: 'sglt2i' },
        { label: 'Another diabetes medicine', value: 'other' },
        { label: 'I do not take diabetes medicine', value: 'none' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q7d-surgery',
      type: 'single',
      progress: 83,
      showBack: true,
      field: 'due_for_operation_or_sedation',
      heading: 'Are you due to have an operation, general anaesthetic or deep sedation?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q7e-other-meds',
      type: 'single',
      progress: 84,
      showBack: true,
      field: 'other_or_recent_medicines',
      heading:
        'Do you take any other prescription or over-the-counter medicines, or have you recently finished taking any medicine?',
      otherValue: 'yes',
      otherPlaceholder: 'Please mention your condition',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q7-clinician-warning',
      type: 'notice',
      hideChrome: true,
      showBack: false,
      showIf: { field: '_needs_clinician_review', equals: true },
      heading: "We'd like to learn more about you",
      body:
        'Based on your answers, one of our clinicians would like to review your case before we proceed. This helps us make sure we recommend the safest and most effective treatment for you.',
      nextLabel: 'Book a Clinician Review',
      nextAction: 'book-clinician',
      showArrow: true
    },
    {
      id: 'q8-allergies',
      type: 'single',
      progress: 85,
      showBack: true,
      field: 'allergies',
      heading: 'Do you have any allergies to medications?',
      otherValue: 'yes',
      otherPlaceholder: 'Please mention your condition',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q9-eating-disorder',
      type: 'single',
      progress: 88,
      showBack: true,
      field: 'diagnosed_eating_disorder',
      heading:
        'Do you have, have you previously had, or suspect that you may have an eating disorder?',
      otherValues: ['yes', 'unsure'],
      otherPlaceholder: 'Please tell us more about it',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
        { label: 'Unsure', value: 'unsure' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q10-photo',
      type: 'upload',
      uploadVariant: 'photo',
      progress: 92,
      showBack: true,
      uploadKey: 'fullbody',
      heading: 'Upload or take a full-body photo of yourself',
      guidelinesKey: 'fullbody',
      showExamples: true,
      cameraLabel: 'Take a photo',
      galleryLabel: 'Upload photo',
      skipLabel: 'Skip for now',
      allowSkip: true,
      requirementsLabel: 'See Upload Requirements',
      nextLabel: 'Continue'
    },
    {
      id: 'q11-id-type',
      type: 'single',
      progress: 96,
      showBack: true,
      field: 'identity_document_type',
      heading: 'Identity Verification upload',
      options: [
        { label: 'Driving Licence', value: 'driving_licence' },
        { label: 'Passport', value: 'passport' },
        { label: 'Other', value: 'other' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q11-photo-id',
      type: 'upload',
      uploadVariant: 'photoId',
      progress: 96,
      showBack: true,
      uploadKey: 'identity',
      idTypeField: 'identity_document_type',
      /* Figma 1596:2157 — shown after selecting Other (and for licence/passport variants) */
      heading: 'Please Upload photo of your ID',
      cameraLabel: 'Take a photo',
      galleryLabel: 'Upload photo',
      skipLabel: 'Skip for now',
      allowSkip: true,
      nextLabel: 'Continue'
    },
    {
      id: 'q11a-safety',
      type: 'infoAck',
      progress: 97,
      showBack: true,
      field: 'treatment_safety_ack',
      heading:
        'Please confirm that you understand the following treatment safety information.',
      confirmLabel:
        'I confirm that all the information I have provided is accurate and truthful to the best of my knowledge. I understand that providing false or misleading information may affect my treatment and the safety of any medication prescribed.',
      nextLabel: 'Continue'
    },
    {
      id: 'q11a2-pre-submit',
      type: 'infoAck',
      progress: 97,
      showBack: true,
      field: 'pre_submit_ack',
      /* Figma 1596:1959 */
      heading: 'Please confirm the following before we submit your assessment',
      bodyList: [
        'I will follow the dose and dose-escalation instructions provided by my prescriber.',
        'I will not take more medication than prescribed.',
        'I understand the importance of staying adequately hydrated.',
        'I understand that weight-loss medication should also be combined with appropriate dietary and lifestyle changes.',
        'I will tell a doctor, surgeon or anaesthetist that I take weight-loss medication before an operation, general anaesthetic or deep sedation.'
      ],
      confirmLabel: 'I agree to all the above points',
      nextLabel: 'Continue'
    },
    {
      id: 'q11b-foundayo',
      type: 'infoAck',
      progress: 98,
      showBack: true,
      field: 'foundayo_contraception_ack',
      /* Annotation: if user cannot accept, remove Foundayo from PLP only */
      showIf: {
        field: 'able_to_become_pregnant',
        in: ['yes', 'unsure', 'prefer-not-to-say']
      },
      heading:
        'Your available treatment options may include Foundayo. Please confirm that you understand the following.',
      bodyList: [
        'Oral hormonal contraception may be less effective for 30 days after starting Foundayo.',
        'This also applies for 30 days after every Foundayo dose increase.',
        'Barrier or non-oral contraception may be required during these periods.',
        'Foundayo must be stopped at least three weeks before a planned pregnancy.'
      ],
      confirmLabel: 'I agree to all the above points',
      nextLabel: 'Continue',
      plpExcludeProductIfDeclined: 'foundayo'
    },
    {
      id: 'q11c-patient-info',
      type: 'infoAck',
      progress: 99,
      showBack: true,
      field: 'patient_info_ack',
      /* Figma 1611:5538 — Q11c. Patient information and side effects */
      heading: 'Please confirm that you understand the following safety information.',
      bodyList: [
        'I will read the Patient Information Leaflet for any treatment prescribed.',
        'I understand that some medicines are subject to additional monitoring.',
        'I understand how to report suspected side effects through the MHRA Yellow Card scheme.',
        'I understand that I must seek appropriate medical assistance if I experience serious symptoms.'
      ],
      confirmLabel: 'I agree to all the above points',
      nextLabel: 'Continue'
    },
    {
      id: 'q12-confirm',
      type: 'confirm',
      progress: 99,
      showBack: true,
      field: 'confirm_accurate',
      heading:
        'Please confirm that you understand the following safety information.',
      bodyList: [
        'I will read the Patient Information Leaflet for any treatment prescribed.',
        'I understand that some medicines are subject to additional monitoring.',
        'I understand how to report suspected side effects through the MHRA Yellow Card scheme.',
        'I understand that I must seek appropriate medical assistance if I experience serious symptoms.'
      ],
      confirmLabel:
        'I confirm that all the information I have provided is accurate and truthful to the best of my knowledge. I understand that providing false or misleading information may affect my treatment and the safety of any medication prescribed.',
      nextLabel: 'Continue'
    },
    {
      id: 'q13-gp-details',
      type: 'gpDetails',
      progress: 100,
      showBack: true,
      /* Figma 2636:47671 — NHS Directory autofill on practice name (Refound gp-details) */
      heading: 'Enter you GP Details',
      body:
        'Due to regulations, we need to inform your GP about this treatment. By providing these details, you consent to us sharing relevant information with your GP and accessing your NHS summary care record when necessary to ensure your safety.',
      nextLabel: 'View my treatment options',
      isFinal: true
    }
  ]
};
